import { render, staticRenderFns } from "./KeywordFluInfo.vue?vue&type=template&id=61a678fc&scoped=true"
import script from "./KeywordFluInfo.vue?vue&type=script&lang=js"
export * from "./KeywordFluInfo.vue?vue&type=script&lang=js"
import style0 from "./KeywordFluInfo.vue?vue&type=style&index=0&id=61a678fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a678fc",
  null
  
)

export default component.exports